// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".anchor[data-v-a6a470a4]:before{content:\" \";display:block;height:64px;margin-top:-64px;pointer-events:none;visibility:hidden}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
